import { useState, useEffect } from "react";
import { auth, functions } from "../../firebase";
import styles from "./styles.module.css";
import { useHistory, useLocation } from "react-router-dom";
const jwt = require("jwt-simple");

export default function PasswordReset() {
  const [token, setToken] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [check, setCheck] = useState("");
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState(false);
  const [pending, setPending] = useState(false);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    try {
      const params = new URLSearchParams(location.search);
      const _token = params.get("token");
      const decoded = jwt.decode(_token, "", true);
      const current_time = Date.now() / 1000;
      if (decoded.exp < current_time) {
        setError({expired: true});
      }
      else {
        setToken(_token);
        setVerified(true);
      }
    }
    catch (err) {
      setError(err);
    }
  }, []);

  const handleReset = async () => {
    if (check === newPassword) {
      setPending(true);
      const fn = functions.httpsCallable("resetPassword");
      fn({ token: token, password: newPassword })
        .then(res => res.data)
        .then(data => {
          auth
            .signInWithEmailAndPassword(data.email, newPassword)
            .then(() => {
              history.push("/home");
            })
            .catch(() => {
              setPending(false);
              setError("Sorry, wrong email or password");
              alert("Sorry, wrong email or password");
            });
        })
        .catch((err) => setError(err));
    }
    else {
      alert("your passwords don't match");
    }
  }

  if (error) {
    if (typeof error === "object" && error.expired) {
      return (
        <div className={styles.authContainer}>
          Your token has expired. Click here to have another link sent to you
        </div>
      )
    }
    else {
      return (
        <div className={styles.authContainer}>{error}</div>
      )
    }
  }
  if (verified) {
    return (
      <div className={styles.authContainer}>
        <div className={styles.containerTitle}>New Password</div>
        <div style={{ marginTop: 20 }}>
          <div>Password</div>
          <input
            className={"input"}
            value={newPassword}
            type="password"
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>
        <div style={{ marginTop: 20 }}>
          <div>Confirm Password</div>
          <input
            className={"input"}
            value={check}
            type="password"
            onChange={(e) => setCheck(e.target.value)}
          />
        </div>
        <div>
          <button disabled={pending} className={styles.authButton} onClick={handleReset}>
            {pending ? "Updating" : "Update Password"}
          </button>
        </div>
      </div>
    )
  }
  return <div>Something went wrong...</div>
}
